/*
 * TIGERRUNS ヘッダーのモバイルドロワー。
 *
 * details/summary をベースにしているので JavaScript が無効でも開閉できる。
 * ここでは aria-expanded の同期、開いたときのフォーカス移動、Esc での閉じる操作、
 * Tab のループ（フォーカストラップ）、外側クリックでの閉じる操作を担当する。
 */
(function () {
  var drawer = document.getElementById('TrBurger');
  if (!drawer) return;

  var toggle = document.getElementById('TrBurgerToggle');
  var panel = document.getElementById('TrBurgerPanel');
  if (!toggle || !panel) return;

  var label = toggle.querySelector('.tr-burger__label');

  function focusable() {
    return Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled])'), function (el) {
      return el.offsetParent !== null;
    });
  }

  function sync() {
    var open = drawer.hasAttribute('open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (label) label.textContent = open ? 'メニューを閉じる' : 'メニューを開く';
  }

  function close(returnFocus) {
    if (!drawer.hasAttribute('open')) return;
    drawer.removeAttribute('open');
    sync();
    if (returnFocus) toggle.focus();
  }

  drawer.addEventListener('toggle', function () {
    sync();
    if (drawer.hasAttribute('open')) {
      var items = focusable();
      if (items.length) items[0].focus();
    }
  });

  // メニュー内のリンクを押したら閉じる（同一ページ内アンカーでも閉じるように）
  panel.addEventListener('click', function (event) {
    if (event.target.closest('a[href]')) close(false);
  });

  document.addEventListener('click', function (event) {
    if (drawer.hasAttribute('open') && !drawer.contains(event.target)) close(false);
  });

  document.addEventListener('keydown', function (event) {
    if (!drawer.hasAttribute('open')) return;

    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      close(true);
      return;
    }

    if (event.key !== 'Tab') return;

    var items = focusable();
    if (!items.length) return;

    var first = toggle;
    var last = items[items.length - 1];
    var active = document.activeElement;

    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  });

  // 幅が広がってドロワーが不要になったら閉じておく
  if (window.matchMedia) {
    var wide = window.matchMedia('(min-width: 990px)');
    var onChange = function (event) {
      if (event.matches) close(false);
    };
    if (wide.addEventListener) {
      wide.addEventListener('change', onChange);
    } else if (wide.addListener) {
      wide.addListener(onChange);
    }
  }

  sync();
})();
